import { clsx } from 'clsx'

interface BadgeProps {
  children: React.ReactNode
  variant?:
    | 'default'
    | 'primary'
    | 'success'
    | 'danger'
    | 'outline'
    // redesign variants
    | 'category'
    | 'expert'
    | 'neutral'
  className?: string
}

export function Badge({ children, variant = 'default', className }: BadgeProps) {
  // shared shape for the original pill variants (kept visually identical)
  const pill = 'px-2.5 py-0.5 rounded-full text-xs font-medium'

  return (
    <span
      className={clsx(
        'inline-flex items-center whitespace-nowrap',
        {
          [`${pill} bg-bg-subtle text-text-secondary`]: variant === 'default',
          [`${pill} bg-brand-primary text-black`]: variant === 'primary',
          [`${pill} bg-green-50 text-green-700`]: variant === 'success',
          [`${pill} bg-red-50 text-danger`]: variant === 'danger',
          [`${pill} border border-border-default text-text-secondary`]: variant === 'outline',
          // redesign: category / topic chip — soft gold on white, uppercase
          'bg-brand-soft text-black uppercase tracking-[0.08em] text-[11px] font-extrabold px-2.5 py-1 rounded-md':
            variant === 'category',
          // redesign: recognition pill — readable gold ink on soft gold (never gold text on white)
          'bg-brand-soft text-[#92710A] text-[11px] font-bold px-2 py-0.5 rounded-full':
            variant === 'expert',
          // redesign: neutral chip — quiet secondary label
          'bg-bg-subtle text-text-muted uppercase tracking-[0.06em] text-[10.5px] font-extrabold px-2 py-0.5 rounded':
            variant === 'neutral',
        },
        className
      )}
    >
      {children}
    </span>
  )
}
